// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2_aSo","detailsBorder":"styles_detailsBorder__3mWKf"};